// extracted by mini-css-extract-plugin
export default {"orgPackUpDiv":"supActivityPackUpload_orgPackUpDiv__6sbYG"};